"use strict";

import BaseModel from "dias/core/models/baseModel";

class Workflowstatusgruppen extends BaseModel {
  constructor() {
    super("workflowstatusgruppen");
  }
}

export default Workflowstatusgruppen;
